import type { MessageResponse } from '@/domain/Api';
import type { Protocol } from '@/domain/Protocol';
import { api } from '@/lib/api';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface ProtocolsResponse extends MessageResponse {
  data: Array<Protocol>;
  meta?: {
    current_page: number;
    last_page: number;
    total: number;
    per_page: number;
  };
}

export interface ProtocolResponse {
  data: Protocol;
}

export const getProtocolsQuery = (page = 1) =>
  queryOptions({
    queryKey: queryKeys.adminProtocols.all(page),
    queryFn: async () => {
      const response = await api
        .get('admin/protocols', { searchParams: { page } })
        .json<ProtocolsResponse>();
      return response;
    },
    placeholderData: keepPreviousData,
  });

export const getProtocolQuery = (id: number) =>
  queryOptions({
    queryKey: queryKeys.adminProtocols.single(id),
    queryFn: async () => {
      const response = await api
        .get(`admin/protocols/${id}`)
        .json<ProtocolResponse>();
      return response.data;
    },
    enabled: id > 0,
  });

export const protocolsQuery = () =>
  queryOptions({
    queryKey: queryKeys.protocols.all(),
    queryFn: async () => api.get('protocols').json<ProtocolsResponse>(),
  });

export const protocolQuery = (id: number) =>
  queryOptions({
    queryKey: queryKeys.protocols.protocol(id),
    queryFn: async () => {
      const response = await api
        .get(`protocols/${id}`)
        .json<ProtocolResponse>();
      return response.data;
    },
    enabled: id > 0,
  });
